/**
 * @date: 2/28/20
 * @author: Yan Wang <ywang@max.md>
 * @copy: (C) Copyright 2020 MaxMD Corporation, All Rights Reserved.
 */


import React, {useEffect, useState} from "react";
import UserDashboard from "./UserDashboard/UserDashboard";
import SignInWithBasicAuth from "./Auth/SignInWithBasicAuth";
import './Home.css';
import {isAccountActive, isAdmin, isMasterAdmin, isSystem, isUserActive} from "./utils/portal-helper";
import ChooseOrganizationWindow from "./Auth/ChooseOrganizationWindow";
import Copyright from "./utils/Copyright";
import {PortalUrl} from "./utils/portal-urls";
import {Alert, Backdrop, CircularProgress, Container} from "@mui/material";
import { makeStyles } from '@mui/styles';
import Box from "@mui/material/Box";
import {useDispatch} from "react-redux";
import {addUser} from "./features/userAccountSlice";


const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff'
    }
}));

export default function Home(props) {
    const [loadingAccount, setLoadingAccount] = useState("Loading");
    const [account, setAccount] = useState(null);
    const [sessionTimedout, setSessionTimedout] = useState(false);
    const [offline, setOffline] = useState(false);
    const classes = useStyles();

    const dispatch = useDispatch();

    useEffect(() => {
        const timmer = setInterval(() => {
            getAccount();
        }, 20000); // check every 20 seconds
        getAccount();
        return () => clearInterval(timmer);
    }, []);

    const handleBasicLoginCompleted = (account) => {
        setAccount(account);
    }
    const handleSignOut = () => {
        fetch(PortalUrl.SignOut);
        setAccount(null);
    }

    const handleTransferCompleted = (account) => {
        setAccount(account);
    }

    const onServerInfoUpdated = (info) => {
        if (info && info.user){
            setAccount(info);
        }
    }
    const getAccount = async () =>{
        fetch(`/api/account`)
            .then(response => {
                return response.text().then(text => {
                    setLoadingAccount(false);
                    if (response.status === 401) {
                        setAccount((account) => {
                            console.log('received 401, inner, account', account);
                            if (account){ // if has session but getting 401 -> session timed out
                                setSessionTimedout(true);
                                setAccount(null);
                                return null;
                                // if (confirm("Your session is over, do you want to signIn again?")){
                                //     const goto = "/auth/signIn?url=" + encodeURIComponent(window.location.pathname + window.location.search);
                                //     console.log("Not authenticated, going to " + goto);
                                //     window.location.replace(goto)
                                // } else {
                                //     // const goto = "/PatientScreening";
                                //     // window.location.replace(goto)
                                // }
                                // account.accessToken = null;
                            }
                            return account;
                        });
                        setOffline(false);
                        return null;
                    } else if (response.status === 502 || response.status === 503 || response.status === 504){
                        console.log('received gateway error ' + response.status + ". The portal is offline.");
                        setOffline(true);
                    } else {
                        setOffline(false);
                    }

                    var data;
                    try{
                        return text && JSON.parse(text);
                    } catch(err) {
                        return Promise.reject("Failed to parse response: " + err);
                    }
                });
            })
            .catch((err) => {
                console.error("Failed to get account, catch error: " , err);
            })
            .then( (res) => {
                if (res) {
                    console.log('Home account', res);
                    if (res.user && res.user.userType === 'tmpEvalUser'){
                        // alert('Invalid User Type: ', res.user.userType);
                    } else {
                        setAccount(res);
                        dispatch(addUser(res));
                    }
                }
                return res;
            });
    }

    if (loadingAccount){
        return <Alert severity="info" icon={false}> <CircularProgress color={"inherit"} /> {loadingAccount} ... </Alert>;
    }

    let userType;
    if (account && account.user && account.user.userType){
        userType = account.user.userType.toUpperCase();
    }

    // if (isAccountActive(account) && account.invitationOrganization && account.invitationOrganization.id !== account.organization.id ){
    //     return (<div> <TransferUserToAnotherOrganization account={account} handleTransferCompleted={handleTransferCompleted} /> </div>);
    // }

    if (!isAccountActive(account)){
        return (<div>
            <SignInWithBasicAuth account={account} handleBasicLoginCompleted={handleBasicLoginCompleted} sessionTimedout={sessionTimedout} />
            <Container maxWidth="lg" className='app-copyright-wrapper' >
                <Box pt={4} className='app-copyright-box'>
                    <Copyright/>
                </Box>
            </Container>

            <Backdrop className={classes.backdrop} open={offline} >
                <CircularProgress color={"inherit"}/> The portal is offline.
            </Backdrop>
        </div>);
    } else {
        //authenticated and activated
        if (isAdmin(account.user) || isSystem(account.user) || isUserActive(account.user)){
            return (
                <div>
                    <UserDashboard signOut={handleSignOut} account={account} onServerInfoUpdated={onServerInfoUpdated} />

                    <Backdrop className={classes.backdrop} open={offline} >
                        <CircularProgress color={"inherit"}/> The portal is offline.
                    </Backdrop>
                </div>
            );
        }

    }
}

